$(document).ready(function () {
  'use strict';

  let body = $('body');
  body.on('click', '.release', function (event) {
    let $this = $(this);
    let modal = $('.notification-header');
    let content = $('.notification-header__body');
    let elementsToHide = $(
      '.admin-sidebar, .admin-help-sidebar, .admin-courses-sidebar'
    );

    if ($this.hasClass('toggle-active')) {
      $this.removeClass('toggle-active');
      modal.removeClass('toggle-active');
      content.html('');

      if (window.innerWidth < 992) {
        elementsToHide.show();
      }

      return false;
    }

    if (content.length === 0) {
      modal.append('<div class="notification-header__body"></div>');
      content = $('.notification-header__body');
    }

    body.find('.toggle-active').removeClass('toggle-active');
    $this.addClass('toggle-active');
    modal.addClass('toggle-active');

    if (window.innerWidth < 992) {
      elementsToHide.hide();
    }

    $.ajax({
      type: 'POST',
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      url: '/release-notification/show-modal',
      success(result) {
        if (result.status) {
          content.html(result?.body);
          // <div class="notification-header__plug">Повідомлень ще немає</div>
        } else {
          content.html(
            '<div class="text-danger">Помилка завантаження даних</div>'
          );
        }
      },
      error() {
        content.html(
          '<div class="text-danger">Помилка підключення до сервера</div>'
        );
      },
    });
  });

  body.on('click', '.notification-header a', function (event) {
    event.stopPropagation();
  });
});
